import React, { useEffect, useState } from "react";
import { Search } from "lucide-react";
import api, { formatRp } from "@/lib/api";
import AdminLayout from "@/components/AdminLayout";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

function CustomerDetail({ id }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/admin/customers/${id}`).then((r) => setD(r.data)); }, [id]);
  if (!d) return <div className="p-4 text-center text-[#5C5C5C]">Memuat...</div>;
  return (
    <div className="space-y-3 max-h-[70vh] overflow-y-auto">
      <div className="bg-[#FAF9F6] rounded-xl p-4">
        <div className="font-bold">{d.name}</div>
        <div className="text-sm text-[#5C5C5C]">{d.email} · {d.phone}</div>
      </div>
      <h4 className="font-bold text-sm">Riwayat Pesanan ({d.orders?.length || 0})</h4>
      {d.orders?.map((o) => (
        <div key={o.id} className="border border-[#E5E5E5] rounded-xl p-3 text-sm">
          <div className="flex items-center justify-between">
            <span className="font-mono text-xs text-[#E85D04]">{o.order_number}</span>
            <span className="text-xs text-[#5C5C5C]">{new Date(o.created_at).toLocaleDateString("id-ID")}</span>
          </div>
          <div className="flex justify-between mt-1">
            <span className="text-[#5C5C5C]">{o.items?.length} item · {o.status}</span>
            <span className="font-bold">{formatRp(o.total)}</span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    api.get("/admin/customers", { params: { search: search || undefined } }).then((r) => setCustomers(r.data));
  }, [search]);

  return (
    <AdminLayout>
      <h1 className="font-display text-3xl font-black mb-1">Pelanggan</h1>
      <p className="text-sm text-[#5C5C5C] mb-4">{customers.length} pelanggan terdaftar</p>

      <div className="bg-white border border-[#E5E5E5] rounded-2xl">
        <div className="p-4 border-b border-[#E5E5E5]">
          <div className="relative max-w-md">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-[#5C5C5C]" size={16} />
            <Input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Cari nama, email, atau telepon..." className="pl-9 rounded-xl" data-testid="cust-search" />
          </div>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[10px] uppercase tracking-widest text-[#5C5C5C] font-bold border-b border-[#E5E5E5]">
                <th className="px-4 py-3">Pelanggan</th>
                <th className="px-4 py-3">Kontak</th>
                <th className="px-4 py-3">Total Pesanan</th>
                <th className="px-4 py-3">Total Belanja</th>
                <th className="px-4 py-3">Bergabung</th>
              </tr>
            </thead>
            <tbody>
              {customers.map((c) => (
                <tr key={c.id} className="border-b border-[#E5E5E5] last:border-0 hover:bg-[#FAF9F6] cursor-pointer" onClick={() => setSelected(c.id)} data-testid={`cust-row-${c.id}`}>
                  <td className="px-4 py-3"><div className="font-semibold">{c.name}</div><div className="text-xs text-[#5C5C5C]">{c.email}</div></td>
                  <td className="px-4 py-3 text-xs">{c.phone || "-"}</td>
                  <td className="px-4 py-3 font-bold">{c.total_orders}</td>
                  <td className="px-4 py-3 font-bold text-[#E85D04]">{formatRp(c.total_spent)}</td>
                  <td className="px-4 py-3 text-xs text-[#5C5C5C]">{c.created_at ? new Date(c.created_at).toLocaleDateString("id-ID") : "-"}</td>
                </tr>
              ))}
              {customers.length === 0 && <tr><td colSpan={5} className="py-12 text-center text-[#5C5C5C]">Tidak ada pelanggan</td></tr>}
            </tbody>
          </table>
        </div>
      </div>

      <Dialog open={!!selected} onOpenChange={(o) => !o && setSelected(null)}>
        <DialogContent>
          <DialogHeader><DialogTitle>Detail Pelanggan</DialogTitle></DialogHeader>
          {selected && <CustomerDetail id={selected} />}
        </DialogContent>
      </Dialog>
    </AdminLayout>
  );
}
